import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import {
    MainContainer,
    MainEntityListItemText,
    MasterDetailsAsideItem,
} from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { CollateralDto } from 'src/generated-api-client';
import { collateralTypesMap } from 'src/pages/CollateralsPage/CollateralTypesMap';

type CollateralListItemProps = { item: CollateralDto };

export const CollateralListItem = observer(
    ({ item }: CollateralListItemProps) => {
        const { t } = useTranslation();

        const collateralType = item.type
            ? t(
                  `data:collateralType.${
                      collateralTypesMap[item.type]?.title || item.type
                  }`,
              )
            : '';

        return (
            <MasterDetailsAsideItem
                to={EntityLinks.collaterals.itemDetails(item.id)}
            >
                <MainContainer>
                    <Tooltip title={item.description}>
                        <EllipsisContainer>
                            <MainEntityListItemText data-testid="collateral-id">
                                {collateralType}
                            </MainEntityListItemText>
                        </EllipsisContainer>
                    </Tooltip>
                </MainContainer>
            </MasterDetailsAsideItem>
        );
    },
);
